import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronTriangleUpMedium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronTriangleUpMedium"><Path d="M12 6.83398L5.14062 15H18.8594L12 6.83398Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronTriangleUpMedium;
